module.exports = { id: "snapchat", url: "/build/app/img/symbols.svg#snapchat", viewBox: "", toString: function() { return this.url; } };